import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class CustomersService {

  // Get customers list
  getCustomers = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc') => {
    return await axios.get(API_URL + '/customers?page=' + pageNum + '&search=' + search + '&limit=' + limit + '&sortBy=' + sortBy + '&sortOrder=' + sortOrder, { headers: authHeader() })
  }

  // Add new customer
  addCustomer = async (customer) => {
    return await axios.post(API_URL + '/customers', customer, { headers: authHeader() })
  }

  // Update customer data
  updateCustomer = async (customer, id) => {
    return await axios.patch(API_URL + '/customers/' + id, customer, { headers: authHeader() })
  }

  // Get customer data
  getCustomer = async (id) => {
    return await axios.get(API_URL + '/customers/' + id, { headers: authHeader() })
  }

  // Delete customer
  deleteCustomer = async (id) => {
    return await axios.delete(API_URL + '/customers/' + id, { headers: authHeader() })
  }

}

export default new CustomersService()